module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('headerTop'), _vm._v(" "), _c('div', {
    staticClass: "swiperImg",
    style: ({
      backgroundImage: 'url(' + _vm.$index.addurl(_vm.img) + ')'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "center page-content flexbetween",
    style: ({
      animation: _vm.animation
    })
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "leftD"
  }, _vm._l((_vm.techList), function(item, index) {
    return _c('div', {
      staticClass: "leftD_child",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "child",
    domProps: {
      "innerHTML": _vm._s(_vm.contents)
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8192e6ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/qyFuwu/fwTixi.vue
// module id = 1107
// module chunks = 1